module.exports = __webpack_public_path__ + "static/media/alert.cce02f86.svg";